module.exports = __webpack_public_path__ + "static/media/user-tie.4d04359f.svg";